import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { useStyles } from '@archipro-design/aria';
import * as S from './DraggablePreview.style';
import type { Coordinates } from '../../type';
import { CSS } from '@dnd-kit/utilities';

export const DraggablePreview = ({ x, y }: Coordinates) => {
    const { setNodeRef, attributes, listeners, transform } = useDraggable({
        id: 'draggable-preview',
    });

    const positionStyles = {
        left: `${x}px`,
        top: `${y}px`,
        transform: CSS.Translate.toString(transform),
        show: x > 0 || y > 0,
    };

    const { css } = useStyles({ ...positionStyles });

    return (
        <div
            className={css(S.DraggableDot)}
            ref={setNodeRef}
            {...attributes}
            {...listeners}
        />
    );
};
